import { CodeSurfer } from "code-surfer";
import processThinking from "../../../../decks/images/process-thinking.jpg";
import oceanicNext from "../../../../decks/theme";
import { Appear, Notes, Head } from 'mdx-deck';
import 'prismjs/components/prism-shell-session';
import "prismjs/components/prism-hcl";
import "prismjs/components/prism-markdown";
import * as React from 'react';
export default {
  CodeSurfer,
  processThinking,
  oceanicNext,
  Appear,
  Notes,
  Head,
  React
};